import { useFormContext, useWatch } from 'react-hook-form';
import {
  CONTRACTOR_AFFILIATION_PREFERENCES,
  CONTRACTOR_LOCATION_PREFERENCES,
} from '@lp/features/admin/forms/ContractorForm/types';
import { LOCATION_PREFERENCES } from '@lp/features/Profile/config';
import { EmployeeFormValues } from '@/types';
import { AffiliationType } from '@/api/apis/resources';

type UseLocationPreferenceParams = {
  isContractor?: boolean;
};

export const useLocationPreference = ({ isContractor }: UseLocationPreferenceParams) => {
  const { control } = useFormContext<EmployeeFormValues>();

  const [affiliationType] = useWatch({
    control,
    name: ['affiliationType'],
  });

  const txCenterPreferencesLabel = CONTRACTOR_AFFILIATION_PREFERENCES.find((v) => v.value === AffiliationType.TXCenter);
  const opoPreferencesLabel = CONTRACTOR_AFFILIATION_PREFERENCES.find((v) => v.value === AffiliationType.OPO);

  const locationPreferences = isContractor ? CONTRACTOR_LOCATION_PREFERENCES : LOCATION_PREFERENCES;

  const getAffiliationLabel = () => {
    if (affiliationType === AffiliationType.TXCenter) return txCenterPreferencesLabel?.name;
    if (affiliationType === AffiliationType.OPO) return opoPreferencesLabel?.name;
    return undefined;
  };

  return {
    control,
    affiliationType,
    locationPreferences,
    getAffiliationLabel,
  };
};
